import { useNavigate } from 'react-router-dom';
import { TableColumn } from '../../components/DataTable/TableColumn';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { UserSummary } from '../../interfaces/User/UserSummary';
import { DateColumn } from '../../components/DataTable/DateColumn';
import { UserOrderField } from '../../interfaces/User/UserFilter';
import { SortingOrder } from '../../interfaces/SortingOrder';
import { Pagination } from '../../interfaces/Pagination';
import { DataTable } from '../../components/DataTable/DataTable';

const columns: TableColumn<UserSummary>[] = [
  {
    id: 'id',
    name: 'ID',
    sortable: true,
    accessor: (row) => <TextColumn value={row.id.toString()} />,
  },
  {
    id: 'name',
    name: 'İsim',
    sortable: true,
    accessor: (row) => (
      <TextColumn value={[row.firstName, row.lastName].join(' ')} />
    ),
  },
  {
    id: 'email',
    name: 'Email',
    sortable: true,
    accessor: (row) => <TextColumn value={row.email} />,
  },
  {
    id: 'phone',
    name: 'Telefon',
    accessor: (row) => <TextColumn value={row.phone} />,
  },
  {
    id: 'point',
    name: 'Puan',
    sortable: true,
    accessor: (row) => <TextColumn value={row.point.toString()} />,
  },
  {
    id: 'created-at',
    name: 'Oluşturulma Tarihi',
    sortable: true,
    accessor: (row) => <DateColumn value={row.createdAt} />,
  },
  {
    id: 'updated-at',
    name: 'Düzenlenme Tarihi',
    sortable: true,
    accessor: (row) => <DateColumn value={row.updatedAt} />,
  },
];

type UsersTableProps = {
  users: UserSummary[];
  totalCount: number;
  orderBy: UserOrderField;
  order: SortingOrder;
  onChangeOrder: (orderBy: UserOrderField, order: SortingOrder) => void;
  pagination: Pagination;
  onPagination: (newPagination: Pagination) => void;
};

export const UsersTable = (props: UsersTableProps) => {
  const navigate = useNavigate();

  return (
    <DataTable
      columns={columns}
      totalCount={props.totalCount}
      rows={props.users}
      limit={props.pagination.pageSize}
      setLimit={(newLimit) =>
        props.onPagination({ page: 0, pageSize: newLimit })
      }
      page={props.pagination.page}
      setPage={(newPage) =>
        props.onPagination({ ...props.pagination, page: newPage })
      }
      orderBy={props.orderBy}
      order={props.order}
      onOrder={(newOrderBy, newOrder) =>
        props.onChangeOrder(newOrderBy as UserOrderField, newOrder)
      }
      onClick={(user) => navigate(`/users/users/${user.id}`)}
    />
  );
};
